<div class="use-external-login">
    <div class="use-external-login__content">
        <img
            *ngIf="signInType === SIGN_IN_TYPES.GOOGLE"
            class="use-external-login__img"
            src="/assets/images/google-element.svg"
        />
        <img
            *ngIf="signInType === SIGN_IN_TYPES.ONE_LOGIN"
            class="use-external-login__img"
            src="/assets/images/Onelogin_Mark_black_RGB.svg"
        />
        <img
            *ngIf="signInType === SIGN_IN_TYPES.OKTA"
            class="use-external-login__img"
            src="/assets/images/okta-icon.svg"
        />
        <img
            *ngIf="signInType === SIGN_IN_TYPES.AZURE"
            class="use-external-login__img"
            src="/assets/images/azure-icon.svg"
        />
        <img
            *ngIf="signInType === SIGN_IN_TYPES.ENTRA"
            class="use-external-login__img"
            src="/assets/images/entra-icon.svg"
        />
        <img *ngIf="signInType === SIGN_IN_TYPES.PING"
             class="use-external-login__img"
             src="/assets/images/ping-icon.svg"
        />
        <span>Signing in with {{ signInLabel$ | async }}</span>
    </div>
</div>
